// extracted by mini-css-extract-plugin
export default {"customBtnWrap":"customBtnWrap--mzzXZ"};